import React, { useState, useEffect } from "react";
import { Card, CardContent, Grid, Typography, Table, TableHead, TableRow, TableCell, TableBody, TextField } from "@deere/fuel-react";
import { DEFAULT_LANGUAGE_CODE, SAVING_DATA } from "../../../../utils/surveyLiterals";
import SelfServiceButtons from "../SelfServiceButtons";
import { validateSurveyTitleTranslations } from "../../../../utils/validation";
import { sortByLanguageList } from "../../../../utils/utils";
import SelfServiceLoader from "../SelfServiceLoader";

const SurveyTranslationStep = ({translationValidation, setTranslationValidation, currentStep, activeStep, setActiveStep, setPayloadData, payloadData, languageList }) => {
  const [error, setError] = useState({ show: false, message: "" });
  const [loader, setLoader] = useState({isLoading: false, message: ""});

  useEffect(() => {
    if(translationValidation) {
      const error = validateSurveyTitleTranslations(payloadData);
      setError(error)
    }
    if (payloadData.language) {
      setPayloadData((prevState) => {
        const newTranslations = [...prevState.translations];
        payloadData.language.forEach((pl) => {
          if (pl.languageCd !== DEFAULT_LANGUAGE_CODE) {
            const index = newTranslations.findIndex((nt) => nt.locale === pl.languageCd);
            index === -1 ? newTranslations.push({ locale: pl.languageCd, language: pl.text, text: "" }) : (newTranslations[index].language = pl.text);
          }
        });
        prevState.translations = [...newTranslations];
        return { ...prevState };
      });
    }
  }, [payloadData.language]);

  const changeHandler = (e) => {
    const locale = e.target.name.split("~")[1];
    setPayloadData((prevState) => {
      const newTranslations = [...prevState.translations];
      const index = newTranslations.findIndex((nt) => nt.locale === locale);
      newTranslations[index].text = e.target.value;
      prevState.translations = [...newTranslations];
      return { ...prevState };
    });
    setError({ show: false, message: "" });
  };

  const fnValidate = (publishHandler) => {
    const error = validateSurveyTitleTranslations(payloadData);
    error.show
      ? setError(error)
      : (setLoader({ isLoading: true, message: SAVING_DATA }), publishHandler(payloadData));
  };

  return (
    <Card>
      <CardContent>
        {loader.message !== "" && <SelfServiceLoader loader={loader} />}
        {loader.message === "" && <Grid container direction="column" rowSpacing={2} justifyContent="space-between" minHeight={"60vh"}>
          <Grid item>
            <Typography variant="h1" mb={2}>
              {currentStep.step} - {currentStep.title}
            </Typography>
            <Typography variant="subtitle">Provide translations for the survey title for the selected languages.</Typography>
          </Grid>
          <Grid item>
            {payloadData.translations.length > 0 ? (
              <Table size="small">
                <TableHead sx={{ border: "none" }}>
                  <TableRow>
                    <TableCell width={"80%"}>Survey Name</TableCell>
                    <TableCell width={"20%"}>Language</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {sortByLanguageList(payloadData.translations, languageList).map((pdt) => (
                    <TableRow key={pdt.locale} sx={{ border: "none!important" }}>
                      <TableCell>
                        <TextField
                          placeholder="Please provide the translation here..."
                          name={`translation~${pdt.locale}`}
                          value={pdt.text}
                          onChange={changeHandler}
                          sx={{ "& .MuiFormLabel-root": { fontSize: "12px" } }}
                        />
                      </TableCell>
                      <TableCell>{pdt.language}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            ) : (
              <Grid item justifyItems="center">
                <Typography>Translations not required. Please proceed to the next step.</Typography>
              </Grid>
            )}
          </Grid>
          {error.show && (
            <Typography variant="subtitle1" color="#C21020" textAlign="right" mt={2}>
              {error.message}
            </Typography>
          )}
          <Grid item pr={5}>
            <Grid container justifyContent="flex-end">
              <SelfServiceButtons
                activeStep={activeStep}
                setActiveStep={setActiveStep}
                fnValidate={fnValidate}
                payloadData={payloadData}
                setPayloadData={setPayloadData}
                setLoader={setLoader}
              />
            </Grid>
          </Grid>
        </Grid>}
      </CardContent>
    </Card>
  );
};

export default SurveyTranslationStep;
